var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trade-mining-section shadow" },
    [
      _c(
        "div",
        { staticClass: "staking-detail" },
        _vm._l(["dSLS", "BTC", "ETH", "USDT"], function(tokenType) {
          return _c("div", { key: tokenType, staticClass: "item" }, [
            _c("div", [
              _vm._v(
                _vm._s(_vm.$t("orderMining.estimate", { name: tokenType }))
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bold" }, [
              _vm._v(_vm._s(_vm.estimateInfo[tokenType] || "--"))
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "wallet-table",
        {
          staticClass: "mint-trade-table no-shadow tb",
          attrs: {
            clickRow: _vm.clickRow,
            headList: _vm.headList,
            contentList: _vm.content
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "detail-wrapper",
              attrs: { slot: _vm.activeIndex + "Row" },
              slot: _vm.activeIndex + "Row"
            },
            [
              _c("loading", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoadingDetail,
                    expression: "isLoadingDetail"
                  }
                ],
                staticClass: "ex-center-loading",
                attrs: { loadingType: "dot" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errMsg,
                      expression: "errMsg"
                    }
                  ],
                  staticClass: "err-msg",
                  on: {
                    click: function($event) {
                      return _vm.fetchDetail(_vm.content[_vm.activeIndex])
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.errMsg))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isLoadingDetail && !_vm.errMsg,
                      expression: "!isLoadingDetail && !errMsg"
                    }
                  ]
                },
                _vm._l(_vm.orderMiningDetails, function(item, i) {
                  return _c(
                    "div",
                    {
                      key: i,
                      staticClass: "slot-row __tb_row __tb_content_row"
                    },
                    [
                      _c("div", { staticClass: "__tb_cell" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("orderMining.market", {
                              name: item.quoteType
                            })
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "__tb_cell" }, [
                        _vm._v(_vm._s(item.ratio))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "__tb_cell" }, [
                        _vm._v(_vm._s(item.mining))
                      ])
                    ]
                  )
                }),
                0
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.content, function(item, i) {
            return _c("span", {
              key: i,
              staticClass: "arrow-icon",
              class: { active: _vm.activeIndex === i },
              attrs: { slot: i + "dateAfter" },
              slot: i + "dateAfter"
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.content, function(item, i) {
            return _c("span", {
              key: i,
              staticClass: "arrow-icon",
              class: { active: _vm.activeIndex === i },
              attrs: { slot: i + "ratioAfter" },
              slot: i + "ratioAfter"
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.content, function(item, i) {
            return _c("span", {
              key: i,
              staticClass: "arrow-icon",
              class: { active: _vm.activeIndex === i },
              attrs: { slot: i + "miningAfter" },
              slot: i + "miningAfter"
            })
          }),
          _vm._v(" "),
          _c("pagination", {
            staticClass: "__tb_pagination",
            attrs: {
              slot: "tableBottom",
              currentPage: _vm.currentPage + 1,
              toPage: _vm.updateData,
              totalPage: _vm.taotalPage
            },
            slot: "tableBottom"
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }